import type { ComponentProps } from 'react'

import { cn } from '@gto/ui/cn'

import { tableStyles } from './table.styles'

// No `size` prop: MUI's density contract is not reproduced here, and a prop that
// silently does nothing is worse than none — cells state their own padding.
export const Root = ({ className, ...props }: ComponentProps<'table'>) => (
  <table
    className={cn(tableStyles().root(), className)}
    {...props}
  />
)
